import React from 'react'

import { Box, Typography } from "@mui/material"
import { formatDate } from "@ui-seeker/utils"
import { dateFormatReceiver } from "@utils"


export default function datesHomeColumn() {

	return {
		name: 'bookingDate',
		label: 'Date',
		render: value => <Box>
			<Typography>{formatDate(value, {
				isString: true,
				receivedFormat: dateFormatReceiver(value)
			})}</Typography>
		</Box>,
	}
}